<template>
	<div class="in-app-icon-svg">
		<svg
			class="center-absolutely"
			:class="{ 'is-show': !isOpen }"
			xmlns="http://www.w3.org/2000/svg"
			width="27.939"
			height="25.942"
			viewBox="0 0 27.939 25.942"
		>
			<path
				id="Path_30412"
				data-name="Path 30412"
				d="M5.954,2.943a65.718,65.718,0,0,1,19.03,0,5.282,5.282,0,0,1,4.454,5.282v8.009a5.282,5.282,0,0,1-4.454,5.282,65.67,65.67,0,0,1-7.879.672.519.519,0,0,0-.354.149L11.185,27.9a1,1,0,0,1-1.7-.705V21.934q-1.77-.162-3.528-.42A5.28,5.28,0,0,1,1.5,16.231V8.225A5.28,5.28,0,0,1,5.954,2.943Z"
				transform="translate(-1.5 -2.25)"
				fill="#fafcff"
				fill-rule="evenodd"
			/>
			<path
				id="Path_30413"
				data-name="Path 30413"
				d="M9.879,7.338a2.531,2.531,0,0,1,3.243,0,1.834,1.834,0,0,1,0,2.838,2.261,2.261,0,0,1-.512.338,1.711,1.711,0,0,0-1.109,1.4v.573m0,3.153h.006v.006H11.5Z"
				transform="translate(2.133 -0.405)"
				fill="none"
				stroke="#5b5be7"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2.5"
			/>
		</svg>
		<svg
			class="center-absolutely"
			:class="{ 'is-show': isOpen }"
			xmlns="http://www.w3.org/2000/svg"
			width="16.672"
			height="9.258"
			viewBox="0 0 16.672 9.258"
		>
			<g id="Group_44572" data-name="Group 44572" transform="translate(-80.5 -1000.943)">
				<g id="Group_44515" data-name="Group 44515" transform="translate(1066.172 302.789) rotate(90)">
					<path
						id="Path_30435"
						data-name="Path 30435"
						d="M14.594.191,7.835,6.78,1.077.191a.612.612,0,0,0-.887,0A.608.608,0,0,0,0,.634a.573.573,0,0,0,.169.422l7.2,7.012a.664.664,0,0,0,.93,0l7.2-6.991a.66.66,0,0,0,.169-.454.585.585,0,0,0-.19-.443A.629.629,0,0,0,15.039,0,.6.6,0,0,0,14.6.19Z"
						transform="translate(698.654 985.172) rotate(-90)"
						fill="#fff"
						stroke="#fff"
						stroke-width="1"
					/>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'InAppIcon',
	props: {
		isOpen: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.in-app-icon-svg {
	height: 50px;
	width: 50px;
	background: #5b5be7;
	border-radius: 50%;
	transition: 0.2s;

	&:hover {
		box-shadow: -1px 1px 8px 2px rgb(93 144 244 / 44%);
		transition: 0.3s;
		cursor: pointer;
	}

	svg {
		&.is-show {
			opacity: 1;
			transition: 0.3s;
		}
		&:not(.is-show) {
			opacity: 0;
			height: 0;
			width: 0;
			transition: 0.3s;
		}
	}
}
</style>
